<template>
  <div v-if="htmlElements">
    <div v-for="(html, index) in htmlElements" :key="index" v-html="html">
    </div>
  </div>
  <span v-else>redirect...</span>
</template>

<script>
  import { api } from '../cmsApi'

  const PrismicDOM = require('prismic-dom')

  export default {
    name: 'Preview',
    data () {
      return {
        content: null,
        htmlElements: null
      }
    },
    async created () {
      if (api.isInit === false) {
        await api.init()
      }
      let documentId = this.$route.query.documentId
      let content = await api.fetchByID(documentId)
      console.log('content > ', content)
      if (content.type === 'topic') {
        this.$router.replace({
          name: 'Topic',
          params: {
            topicId: documentId
          }
        })
      } else if (content.type === 'page') {
        console.log(content)
        let contentIds = content.data.contents.map(x => x.content.id)
        let contents = await api.fetchByIDs(contentIds)
        this.htmlElements = contents.map(x => PrismicDOM.RichText.asHtml(x.data.content))
      }
    }
  }
</script>

<style scoped>

</style>
